/** Strings owned by `src/features/users/` — WP-12's Users section (scoped
 * to the active company), `UserDetailPage`, `UserEditPage`, `AddPersonPage`
 * et `memberActions.tsx` (§ Bedrijfscontext, § Zichtbaarheid). */
export const users = {
  page: {
    title: 'Utilisateurs',
    noScope:
      'Vous n’avez aucune autorité administrative, il n’y a donc aucune liste de membres à afficher.',
    departmentListsTitle: 'Listes de membres par département',
    leadCompany: 'Membres de {{company}}.',
    membersOf: 'Membres de {{company}}',
    companyMembersCardTitle: 'Membres',
    addPerson: 'Ajouter une personne',
    empty: 'Aucun membre.',
    name: 'Nom',
    email: 'E-mail',
    login: 'Connexion',
    source: 'Source',
    yes: 'oui',
    no: 'non',
    invitePerson: 'Inviter',
    importCsv: 'Importer un CSV',
    searchPlaceholder: 'Rechercher par nom ou e-mail…',
    filterDepartment: 'Département',
    allDepartments: 'Tous les départements',
    filterLocation: 'Site',
    allLocations: 'Tous les sites',
    filterStatus: 'Statut',
    allStatuses: 'Tous les statuts',
    employee: 'Employé',
    department: 'Département',
    location: 'Site',
    lastSync: 'Dernière synchro',
    consent: 'Consentement',
    wearable: 'Wearable',
    pilot: 'Pilote',
    account: 'Compte',
    actions: 'Actions',
    accountActive: 'Actif',
    accountDeactivated: 'Désactivé',
    noLocation: 'Aucun site',
    noDepartment: 'Aucun département',
    activation: {
      label: 'Activation',
      invited: 'Invité',
      activated: 'Activé',
      active: 'Actif',
      inactive: 'Inactif',
      deactivated: 'Désactivé',
    },
    consentStatus: {
      pending: 'En attente',
      confirmed: 'Confirmé',
      declined: 'Retiré',
      none: 'Aucun',
    },
  },
  detail: {
    thisPerson: 'cette personne',
    edit: 'Modifier',
    name: 'Nom',
    email: 'E-mail',
    nickname: 'Surnom',
    preferredLanguage: 'Langue préférée',
    region: 'Région',
    login: 'Connexion',
    yes: 'oui',
    no: 'non',
    gender: 'Genre',
    birthdate: 'Date de naissance',
    height: 'Taille',
    weight: 'Poids',
    privateNote:
      'Le genre, la date de naissance, la taille et le poids sont privés pour cette personne et ne font partie de la vue de personne d’autre sur elle.',
    actionsCardTitle: 'Actions',
    statsCardTitle: 'Statistiques',
  },
  edit: {
    title: 'Modifier les informations personnelles',
    lead: 'Le nom et l’e-mail proviennent du compte de connexion et ne peuvent pas être modifiés ici.',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  addPerson: {
    created: 'Personne créée.',
    inviteSent: 'Un e-mail d’invitation est en route.',
    alreadyHasLogin: 'Cette personne a déjà une connexion.',
    noLoginYet:
      'Pas encore de connexion — vous pourrez l’inviter plus tard depuis la liste des membres.',
    done: 'Terminé',
    name: 'Nom',
    email: 'E-mail',
    emailHint: 'Facultatif — avec une adresse, la personne est invitée à se connecter.',
    nickname: 'Surnom',
    region: 'Région',
    conflict:
      'Une personne avec cette adresse e-mail existe déjà{{reason}}. Ajoutez cette personne existante à la portée au lieu d’en créer une en double.',
    cancel: 'Annuler',
    create: 'Créer la personne',
    companyTitle: 'Ajouter une personne à l’entreprise',
    departmentTitle: 'Ajouter une personne au département',
    newPersonCardTitle: 'Nouvelle personne',
    existingCardTitle: 'Membre existant de l’entreprise',
    existingPersonCardTitle: 'Personne existante',
    member: 'Membre',
    person: 'Personne',
    choose: 'Choisir…',
    addToDepartment: 'Ajouter au département',
    addToCompany: 'Ajouter à l’entreprise',
    searchPeople: 'Rechercher des personnes',
    searchPlaceholder: 'Nom ou e-mail',
    noEligible: 'Aucune personne correspondante trouvée.',
    editionMismatch:
      'L’édition de cette personne diffère de celle de l’entreprise. Modifiez d’abord l’édition de la personne ou de l’entreprise, puis réessayez.',
  },
  actions: {
    invite: 'Inviter',
    inviteAgain: 'Inviter à nouveau',
    changeEmail: 'Changer l’e-mail',
    newEmail: 'Nouvelle adresse e-mail',
    save: 'Enregistrer',
    cancel: 'Annuler',
    remove: 'Retirer',
    unlink: 'Dissocier',
    unlinkFromPilot: 'Dissocier du pilote',
    erase: 'Effacer',
    changeLocation: 'Changer de site',
    changeDepartment: 'Changer de département',
    deactivate: 'Désactiver',
    activate: 'Activer',
  },
  invite: {
    title: 'Inviter une personne',
    name: 'Nom',
    email: 'Adresse e-mail',
    role: 'Rôle',
    roleMember: 'Employé',
    roleAdmin: 'Administrateur d’entreprise',
    submit: 'Inviter',
    cancel: 'Annuler',
  },
  import: {
    title: 'Importer un CSV',
    instructions: 'Collez ou importez un CSV avec les colonnes : nom, e-mail, département, site.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Ou importer un fichier',
    submit: 'Importer',
    cancel: 'Annuler',
    done: 'Terminé',
    summary: '{{imported}} importé(s), {{failed}} échoué(s).',
    rowLabel: 'Ligne {{row}}',
    rowSuccess: 'Importé',
    rowFailed: 'Échoué',
  },
} as const;
